import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({name: 'leftPad'})
export class LeftPadPipe implements PipeTransform {
  transform(value: any, args: number = 7): any {
    if (!value) return value;
    let converted: any = value;

    let pipe = new DecimalPipe('en-US');
    if (!isNaN(value)) {
      converted = pipe.transform(value, '1.2-2');
    }

    let length = args - converted.toString().length;
    return length > 0 ? ' '.repeat(length) + converted : converted;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/left-pad.pipe.ts